import axiosClient from "@/api/common/axiosClient.ts";
import { PaginatedResponse } from "@/api/types.ts";
import { Draw, DrawStatus } from "@/types/draw.ts";

export const customParamsSerializer = (
  params: Record<string, unknown>,
): string => {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined) return;

    if (Array.isArray(value)) {
      value.forEach((v) => {
        if (v !== undefined) {
          searchParams.append(key, String(v));
        }
      });
    } else {
      searchParams.append(key, String(value));
    }
  });

  return searchParams.toString();
};

export const getDraws = ({
  status,
  search,
  sortKey,
  sortOrder,
}: {
  status?: DrawStatus[];
  search?: string;
  sortKey: "popular" | "new" | "prize" | "price" | string;
  sortOrder: "desc" | "asc";
}) => {
  return axiosClient.get<PaginatedResponse<Draw>>("draws/public/", {
    params: { status, search, sort: sortKey, order: sortOrder },
    paramsSerializer: customParamsSerializer,
  });
};
